// ----------------------------------------------------------------------
// <copyright file="Izenda.SmartTagDetail.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {

  var m = require('mobx');  

  function SmartTagDetail(data) {
    var props = {
      category: null,
      created: null,
      createdBy: null,
      dataType: null,
      description: null,
      format: null,
      groupBy: null,
      id: null,
      inserted: false,
      modified: null,
      modifiedBy: null,
      name: null,
      position: null,
      state: null,
      subCategory: null,
      version: null
    };

    m.extendObservable(this, props);
    data && this.populateData(data);
  }

  /**
   * Populate data
   * @param  {Object} embed report detail data
   */
  SmartTagDetail.prototype.populateData = m.action(function (data) {
    this.category = data.category;
    this.created = data.created;
    this.createdBy = data.createdBy;
    this.dataType = data.dataType;
    this.description = data.description;
    this.format = data.format;
    this.groupBy = data.groupBy;
    this.id = data.id;
    this.inserted = data.inserted;
    this.modified = data.modified;
    this.modifiedBy = data.modifiedBy;
    this.name = data.name;
    this.position = parseInt(data.position, 10);
    this.state = data.state;
    this.subCategory = data.subCategory;
    this.version = data.version;
  });
  
  module.exports = SmartTagDetail;
}();



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.SmartTagDetail.js